export const attemptToParseJSON = (response) => {
  // if is a json, return the response
  // if not, parse the json and return the parsed json
  try {
    return JSON.parse(response);
  } catch (error) {
    return response;
  }
}
